import React from 'react'
import Logo from 'images/common/logo.svg'
import { Link } from 'react-router-dom'
import Facebook from 'images/common/icon_facebook_circle.svg'
import X from 'images/common/icon_twitter_circle.svg'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'
import { LinksProps } from './types'
import styles from './Links.module.scss'

export const StyledLinks: React.FC<LinksProps> = ({ links, jobOfferLinks, otherLinks }) => {
  const isMobile = useIsMobile()
  const socialIconWidth = isMobile ? 28 : 32

  return (
    <section className={`flex flex-col px-M py-2XL gap-2XL tablet:px-3XL desktop:flex-row ${styles.links}`}>
      <section className="flex justify-between items-center w-full desktop:w-auto desktop:flex-col desktop:justify-start desktop:items-start desktop:gap-XL">
        <img src={Logo} alt="クラウドワークス テック" width={isMobile ? 130 : 198} />
        <div className="flex items-center gap-S tablet:gap-M">
          <a href="https://www.facebook.com/crowdtech.jp" target="_blank">
            <img src={Facebook} alt="facebook" width={socialIconWidth} />
          </a>
          <a href="https://x.com/CrowdWorks_tech" target="_blank">
            <img src={X} alt="X" width={socialIconWidth} />
          </a>
        </div>
      </section>
      <section className="flex flex-col gap-3XL tablet:gap-5XL tablet:flex-row desktop:px-2XL">
        <div className="flex gap-3XL tablet:gap-5XL">
          <ul className="flex flex-col gap-S">
            {links.map(link => (
              <li key={link.name} className="text-XS">
                <a href={link.href}>{link.name}</a>
              </li>
            ))}
          </ul>
          <div className="flex flex-col gap-S text-XS">
            <Link to="/job_offers">掲載案件</Link>
            <ul className="flex flex-col gap-S pl-XS">
              {jobOfferLinks.map(link => (
                <li key={link.name}>
                  <Link to={link.to}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <ul className="flex flex-col gap-S text-XS">
          {otherLinks.map(link => (
            <li key={link.name}>
              <a href={link.href}>{link.name}</a>
            </li>
          ))}
        </ul>
      </section>
    </section>
  )
}
